import { combineReducers } from '@reduxjs/toolkit'
import { main } from '../slices/main'
import { recovery } from '../slices/recovery'
import { cashPayment } from '../slices/cash-payment'
import { instalmentPlan } from '../slices/instalment-plan'
import { sales } from '../slices/sales'
import { task } from '../slices/task'
import { undiruvchiList } from '../slices/undiruvchiList'

const rootReducer = combineReducers({
	main: main.reducer,
	recovery: recovery.reducer,
	cashPayment: cashPayment.reducer,
	instalmentPlan: instalmentPlan.reducer,
	sales: sales.reducer,
	task: task.reducer,
	undiruvchiList: undiruvchiList.reducer,
})

// Named function for the default export
const rootReducerWrapper = (state, action) => rootReducer(state, action)

export default rootReducerWrapper
